var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-loading': _vm.isLoading },attrs:{"id":"map-wrapper"}},[_c('div',{ref:"canvas",staticClass:"map-canvas",attrs:{"id":"map-canvas"}}),_c('div',{attrs:{"id":"loader"}},[_c('Loader',{attrs:{"color":"#f5ad23"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }